import { CircleCheck } from "lucide-react";
interface ChecklistItem {
  id: string;
  text: string;
  checked: boolean;
}

interface ChecklistItemComponentProps {
  item: ChecklistItem;
  accent?: string;
}

export function ChecklistItemComponent({ item, accent = "cyan" }: ChecklistItemComponentProps) {
  // Map accent to actual color values for inline styles
  const accentColors: Record<string, { border: string; icon: string; glow: string }> = {
    cyan: { 
      border: "hsla(190, 95%, 55%, 0.25)", 
      icon: "hsl(190, 95%, 55%)",
      glow: "0 0 20px -5px hsla(190, 95%, 55%, 0.4)",
    },
    teal: { 
      border: "hsla(172, 66%, 50%, 0.25)", 
      icon: "hsl(172, 66%, 50%)",
      glow: "0 0 20px -5px hsla(172, 66%, 50%, 0.4)",
    },
    purple: { 
      border: "hsla(280, 85%, 65%, 0.25)", 
      icon: "hsl(280, 85%, 65%)",
      glow: "0 0 20px -5px hsla(280, 85%, 65%, 0.4)",
    },
    gold: { 
      border: "hsla(300, 70%, 55%, 0.25)", 
      icon: "hsl(300, 70%, 55%)",
      glow: "0 0 20px -5px hsla(300, 70%, 55%, 0.4)",
    },
  };

  const colors = accentColors[accent] || accentColors.cyan;

  return (
    <div 
      className="group relative py-2 pl-10 pr-4 rounded-xl transition-all duration-300 hover:scale-[1.01]"
      style={{ 
        background: "linear-gradient(135deg, hsla(240, 50%, 13%, 0.95) 0%, hsla(270, 40%, 16%, 0.9) 50%, hsla(220, 35%, 13%, 0.95) 100%)",
        border: `1px solid ${colors.border}`,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = colors.glow;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {/* Check icon INSIDE the box on the left */}
      <div className="absolute left-3 top-1/2 -translate-y-1/2">
        <CircleCheck 
          size={16}
          style={{ color: colors.icon }}
          className="opacity-80"
        />
      </div>

      {/* Speech bubble tail - SVG for border support */}
      <svg
        className="absolute left-0 top-[60%] -translate-x-full -translate-y-1/2"
        width="8" 
        height="12" 
        viewBox="0 0 8 12"
      >
        <path 
          d="M8 0 L0 6 L8 12" 
          fill="hsla(240, 50%, 13%, 0.95)"
          stroke={colors.border}
          strokeWidth="1"
        />
      </svg>
      
      {/* Text content */}
      <span className="text-base text-foreground/90 leading-relaxed block">
        {item.text}
      </span>
    </div>
  );
}
